import { TFunction } from '../Provider/UiComponentsProvider'
import { AccessAccount, AccessTeam, TeamContributor, UserAccess } from './types'

export const CONTRIBUTOR_RIGHTS = (t?: TFunction | null) =>
  ({
    VIEWER: { value: 'VIEWER', label: t?.('access.viewer') },
    EDITOR: { value: 'EDITOR', label: t?.('access.editor') },
    OWNER: { value: 'OWNER', label: t?.('gridHeaderName.owner') }
  }) as Record<UserAccess, { value: UserAccess; label: string }>

export const teamToContributor = (
  team: AccessTeam,
  resourceOwner: AccessAccount
): TeamContributor => {
  const viewPremission = CONTRIBUTOR_RIGHTS().VIEWER.value
  const editPermission = CONTRIBUTOR_RIGHTS().EDITOR.value

  const { members, teamLead } = team

  const teamLeader = {
    account: teamLead,
    access: teamLead?.id === resourceOwner?.id ? editPermission : viewPremission
  }

  const teamMembers = members
    .map(({ account }) => ({
      account,
      access:
        account?.id === resourceOwner?.id ? editPermission : viewPremission
    }))
    .filter((u) => u.account.id !== teamLeader.account.id)

  return { team, contributors: [teamLeader, ...teamMembers] }
}
